<div class="agent-screen">
    <ng-container *ngIf="listView">
        <form (submit)="getRetrieveQuote(searchType, mobile)">
            <div class="radio-btns">
                <span><input type="radio" name="searchType" value="Mobile" (change)="mobile = ''" [(ngModel)]="searchType" /> Mobile</span>
                <span><input type="radio" name="searchType" value="Quote Id" (change)="mobile = ''" [(ngModel)]="searchType" /> Quote Id</span>
            </div>
            <div class="form-group">
                <input type="text" name="mobile" [(ngModel)]="mobile" placeholder="{{searchType}}"
                    class="form-control" />
                    <div *ngIf="isQuoteMessage" class="text-center">
                    <small class="error">
                        No quote found by this quoteID. </small>
                    </div>
                    <div *ngIf="isCorrectMobile" class="text-center">
                        <small class="error">
                            Please enter valid and registered mobile number.</small>
                    </div>
                    <div *ngIf="isMobileMessage" class="text-center">
                        <small class="error">
                            No quote found by this mobile number.</small>
                    </div>
            </div>
            <div class="form-group text-center">
                <button type="submit" class="btn-sm btn-blue">Submit</button>
            </div>
        </form>

        <div class="reterive-list" *ngIf="retrieveProspects.length > 0">
            <h3>Requested Quotes</h3>
            <table>
                <thead>
                    <tr>
                        <th>Product Name</th>
                        <th>Date</th>
                        <th>Premium</th>
                        <th>Quote Id</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let prospect of retrieveProspects" (click)="showDetaildView(prospect)">
                        <td>{{prospect.product}}</td>
                        <td>{{prospect.date | date}}</td>
                        <td>{{prospect.premium}}</td>
                        <td>{{prospect.quoteId}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="text-center" *ngIf="retrieveProspects.length === 0">
            <p>No Result found.</p>
        </div> -->
    </ng-container>

    <div class="reterive-detail" *ngIf="detailedView">
        <h3>Requested Quotes</h3>
        <div class="flex-container">
            <div class="flex-group">
                <label>Product Name</label>
                <p>{{detailedData.product}}</p>
            </div>
            <div class="flex-group">
                <label>Date</label>
                <p>{{detailedData.date | date}}</p>
            </div>
            <div class="flex-group">
                <label>Premium</label>
                <p>{{detailedData.premium}}</p>
            </div>
            <div class="flex-group">
                <label>Quote ID</label>
                <p class="quote-id">{{detailedData.quoteId}}</p>
            </div>
            <div class="flex-group">
                <label>Insurer</label>
                <p>
                    <span *ngFor="let ins of detailedData.insurers">{{ins}},</span>
                </p>
            </div>
            <div class="flex-group">
                <label>Quote Initiated by</label>
                <p>{{detailedData.quoteInitiatedBy}}</p>
            </div>
            <div class="flex-group">
                <label class="block">Send Via</label>
                <!-- <span class="blue-brdr-btn" (click)="sendEmail()">Mail</span> -->
                <span class="blue-brdr-btn" id="sendmail" data-toggle="modal" data-target=".confirm-send-mail">Mail</span>
                
                <!-- <span class="blue-brdr-btn" (click)="sendSms()">SMS</span> -->
                <span class="blue-brdr-btn" id="copylink" (click)="copyViewUrl(detailedData.view)">Copy Link</span>
                <span class="blue-brdr-btn" id="closeDetail" (click)="closeDetails()">Close Details</span>

            </div>
        </div>
    </div>  
</div>
<div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
</div>
<div class="modal fade confirm-send-mail " >
    <div class="modal-dialog modal-dialog-centered modal-sm ">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="form-group text-center">
            <small><b>Are you sure want to send quote Id to user</b></small>
            <div class="container">
              <div class="col-md-12 text-center pt-2">
              <button type="button" class="btn btn-primary btn-sm mx-2" (click)="sendEmail()" data-dismiss="modal">Yes</button>
              <button type="button" class="btn btn-danger btn-sm mx-2" data-dismiss="modal">No</button>
            </div>
            </div>
          </div>
        </div>
        </div>
        </div>
        </div>
        <div class="modal fade" id="confirmCopied" >
            <div class="modal-dialog modal-dialog-centered modal-sm ">
              <div class="modal-content">
                <!-- Modal body -->
                <div class="modal-body">
                  <div class="form-group text-center">
                    <small><b>Link copied successfully.</b></small>
                  </div>
                </div>
                </div>
                </div>
                </div>
                <div class="modal fade" id="confirmedSentMail" >
                    <div class="modal-dialog modal-dialog-centered modal-sm ">
                      <div class="modal-content">
                        <!-- Modal body -->
                        <div class="modal-body">
                          <div class="form-group text-center">
                            <small><b>Mail sent successfully.</b></small>
                          </div>
                        </div>
                        </div>
                        </div>
                        </div>